import { useSuspenseQuery } from '@apollo/client';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';
import {
  FETCH_REPORTING_TOOLS_HEADER,
  FetchReportingToolsHeaderQuery,
  FetchReportingToolsHeaderQueryVariables,
} from '@edwin-group/cj-graphql';
import { Error } from '../error';

export const Header = () => {
  const { academicYear, schoolDocumentIds } = useReportingToolsStore((state) => state.filters);
  const page = useReportingToolsStore((state) => state.page);
  const { data, error } = useSuspenseQuery<FetchReportingToolsHeaderQuery, FetchReportingToolsHeaderQueryVariables>(
    FETCH_REPORTING_TOOLS_HEADER,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        academicYear,
        schoolDocumentIds,
      },
      errorPolicy: 'all',
    },
  );

  if (error) {
    return <Error error={error} />;
  }

  const header = data?.fetchReportingToolsHeader;

  const renderHeader = ({ title, value }: { title: string; value?: number | null }) => {
    return (
      <div className="flex flex-col items-center p-4 md:gap-2 md:rounded-2xl md:border md:border-gray-500 md:p-5">
        <label className="text-center text-sh-xxxs md:text-sh-xxs">{title}</label>
        <div className="text-center text-sh-xxxs font-bold md:text-sh-md">{value || '-'}</div>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-4 flex-wrap gap-4 rounded-2xl border border-black px-5 md:grid-cols-1 md:grid-cols-2 md:border-none md:px-0 lg:grid-cols-4">
      {renderHeader({
        title: page?.header?.missionsCompleted || '',
        value: header?.missionsCompleted,
      })}
      {renderHeader({
        title: page?.header?.exercisesCompleted || '',
        value: header?.exercisesCompleted,
      })}
      {renderHeader({ title: page?.header?.cohortsTaught || '', value: header?.cohortsTaught })}
      {renderHeader({
        title: page?.header?.assessmentsCompleted || '',
        value: header?.assessmentsCompleted,
      })}
    </div>
  );
};
